var map = {
	"./pohjanmuoto_kapea_l.png": "C79d",
	"./pohjanmuoto_l.png": "r0Ko",
	"./pohjanmuoto_lieva_l.png": "6Qxk",
	"./pohjanmuoto_matala_t.png": "VmZb",
	"./pohjanmuoto_matala_x.png": "pOKz",
	"./pohjanmuoto_nelio.png": "wyAm",
	"./pohjanmuoto_s.png": "Yufc",
	"./pohjanmuoto_s_muunnelma.png": "zsCA",
	"./pohjanmuoto_suorakaide.png": "uYcE",
	"./pohjanmuoto_suorakaide_pitka.png": "Fi1l",
	"./pohjanmuoto_symmetrinen_x.png": "fz/T",
	"./pohjanmuoto_t.png": "xI7i",
	"./pohjanmuoto_x_muunnelma.png": "Ovzv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4P+j";


//////////////////
// WEBPACK FOOTER
// ./src/assets/options ^\.\/pohjanmuoto_.*\.png$
// module id = 4P+j
// module chunks = 0